
import { z } from "zod";

export const SiteVisitReinspectionFaultValues = ["PARTNER", "REMI"] as const;
export const SiteVisitReinspectionFaultSchema = /* @__PURE__ */ z.enum(SiteVisitReinspectionFaultValues);
export const SiteVisitReinspectionFault: (typeof SiteVisitReinspectionFaultSchema)["enum"] = { "PARTNER": "PARTNER", "REMI": "REMI" };
export type SiteVisitReinspectionFault = (typeof SiteVisitReinspectionFaultValues)[number];
export const SiteVisitReinspectionFaultDisplayNames = { "PARTNER": "Partner",
"REMI": "Remi", } satisfies Record<SiteVisitReinspectionFault, string>;
